import request from '@/utils/request'
import { decorType } from '@/utils/decor-types'
import { api } from '~/ui-domain'

export function getVisibleGoodsGroups() {
  const url = decorType === 'admin'
    ? 'admin/goods/groups'
    : `${api.seller}/seller/goods-groups`
  return request({ url, method: 'get', loading: false })
}

export function getVisibleGoodsGroup(id) {
  const url = decorType === 'admin'
    ? `admin/goods/groups/${id}/preview`
    : `${api.seller}/seller/goods-groups/${id}`
  return request({ url, method: 'get', loading: false })
}
